import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { UserService } from '../pages/admins/user.service';

export const authGuard: CanActivateFn = (route, state) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);
  const userService = inject(UserService);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    switchMap(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
      }

      return userService.bootstrapCurrentUser().pipe(
        map(() => true),
        catchError(() => of(router.createUrlTree(['/forbidden']))),
      );
    }),
  );
};
